"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncorrectWishlistState = void 0;
const wishlist_exception_1 = require("./wishlist-exception");
class IncorrectWishlistState extends wishlist_exception_1.WishlistException {
    constructor() {
        super('ExpectedState doesn\'t match current state of wishlist');
        this.name = 'IncorrectWishlistState';
    }
}
exports.IncorrectWishlistState = IncorrectWishlistState;
